import React, { useContext, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';

import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';

const DetachCategoryModal = ({ modalDetails }) => {
  const data = modalDetails;
  const { categoryId, parentCategoryId } = data;
  
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  
  const [isDetaching, setIsDetaching] = useState(false);

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleDetach = async () => {
    try {
      setIsDetaching(true);
      
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/category/${categoryId}/detach`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        },
        body: JSON.stringify({
          parentCategoryId: parentCategoryId
        })
      });

      if (!response.ok) {
        throw new Error('Failed to detach category');
      }

      const result = await response.json();
      console.log('Category detached successfully:', result);
      
      // Trigger page refresh
      modalCtx.setPageUpdate({ page: "Categories", categoryId: categoryId });
      
      // Close modal
      closeHandle();
      
    } catch (error) {
      console.error('Error detaching category:', error);
    } finally {
      setIsDetaching(false);
    }
  };

  return (
    <div className="modal-container">
      <div className='modal-header'>
        <h1>Detach Category</h1>
      </div>
      <div className="modal-body">
        <span>Are you sure you want to detach this category?</span><br/>
        <span style={{fontSize: "12px", color: "#555"}}>
          This will remove the parent-child relationship between these categories.
        </span>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={isDetaching}>CANCEL</Button>
        <Button onClick={handleDetach} disabled={isDetaching} variant="contained">
          {isDetaching ? <CircularProgress size={16} color="inherit" /> : "DETACH"}
        </Button>
      </div>
    </div>
  );
};

export default DetachCategoryModal;
